import React from 'react';
import { Card } from 'react-bootstrap';
import CardIcon from '../assets/gptw_icons/Icons_rot/activity-heart.png';

const CustomCard = ({ title, text, children }) => {
  return (
    <Card className="flex-fill">
      <Card.Body>
        <img src={CardIcon} alt="Card icon" className="mb-2" />
        <Card.Title><b>{title}</b></Card.Title>
        <Card.Text>
          {text}
        </Card.Text>
        {children && (
          <div className="d-flex justify-content-center mt-3">
            {children}
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default CustomCard;